import LeaderModule from './LeaderModule';

export default LeaderModule;
